// extracted by mini-css-extract-plugin
export default {"main1":"Cart_main1__gvzun","main":"Cart_main__LOn2C","main3":"Cart_main3__hxT2v","main2":"Cart_main2__yE9W6","bbt":"Cart_bbt__y9Z2p"};